import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import PromoColsWrapper from '../front/PromoColsWrapper';
import StageMosaic from '../front/StageMosaic';

const PromotionStageMosaic = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const promo = props?.promo ?? {};

	const default_description_text = `<h1>${i18n("Participation stages")}</h1><p>${i18n("Click on the stage you want to participate in. The stage must be open.")}</p>`;
	const stages_description = (isNotEmpty(promo, 'stages_mosaic_description')) ? promo.stages_mosaic_description : default_description_text;

	return (
		<div class="layout_conts">
			<PromoColsWrapper
				main_image={promo?.mosaic_image && promo.full_mosaic_image}
				main_video={promo.mosaic_video}
				main_description={stages_description}
			>
				<article class="promo_data template_module info_flexwrap gui_main_actions">
					{(props.stages.length > 0) ? (
						<StageMosaic zone='mosaic' {...props} />
					) : (
						<div class="gui_main_text_color_on_bg gui_not_in_top_huge">{i18n("There's no participation stage available")}.</div>
					)}
				</article>
			</PromoColsWrapper>
		</div>
	);
}

export default injectIntl(PromotionStageMosaic);